import { render, staticRenderFns } from "./Dy4GCollectManage.vue?vue&type=template&id=0473c4f2&"
import script from "./Dy4GCollectManage.vue?vue&type=script&lang=js&"
export * from "./Dy4GCollectManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports